/**
 * @voltxampere/ui — Photodiode array (Sprint 45-4, placeholder)
 *
 * PLACEHOLDER. Multi-element photodiode array — gerçek N-element
 * paralel photodiode + light-sensitive area mapping Sprint 47+
 * engine extension #4 ile. Şu anki stamp tek photodiode
 * placeholder.
 *
 * Reference: Generic Si photodiode array — Hamamatsu S4111
 * series, Vishay TEFD4300, Perkin Elmer PSD. 2-256 element line/
 * matrix, spectral 350-1100 nm, photoresponse 0.5-0.6 A/W. Image
 * sensor (line scanner, CCD/CMOS pre-cursor), barcode reader,
 * spectrometer, position sensitive detector (PSD).
 *
 *   Default mapping → diode schemaType:
 *     saturationCurrent = 1e-12 (photodiode dark current elevated)
 *     ideality = 1
 *
 * Engine zero-diff invariant honored — canonical `diode` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diode } from "../diode.js";
export const diodePhotodiodeArray = {
    id: "photodiode-array",
    nameTr: "Photodiode Array (Hamamatsu-class, placeholder)",
    nameEn: "Photodiode Array (Hamamatsu-class, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: diode.viewBox,
    terminals: diode.terminals,
    defaultLabel: "D",
    defaultValue: "PD-ARRAY",
    schemaType: "diode",
    defaultParams: { saturationCurrent: 1e-12, ideality: 1 },
    renderSVG: () => diode.renderSVG(),
};
//# sourceMappingURL=diode-photodiode-array.js.map